import React from 'react'
import {Link} from 'react-router-dom'
import {Card, CardText, Col, ListGroupItem} from 'reactstrap'
import '../../stylesheets/ControlPanel.css'


let ControlPanelItem = ({icon, text, smallText, href}) =>
    <Col xs={12} sm={10} md={4} lg={3} className="m-0 p-0">
        <Link className="control-panel-link" to={href}>
            <Card body className="control-panel-card d-none d-md-block bg-muted-sf-orange border-light-sf-orange">
                <div className="ml-auto mr-auto mb-4 mt-2">{icon}</div>
                <CardText>
                    {smallText ?
                        <span>
                            <span className="d-none d-sm-inline-block d-xl-none">{smallText}</span>
                            <span className="d-inline-block d-sm-none d-xl-inline-block">{text}</span>
                        </span>:
                            text}
                    </CardText>
            </Card>
            <ListGroupItem className="control-panel-li col-10 offset-1 d-block d-md-none bg-muted-sf-orange border-light-sf-orange">
                <span className="mr-2">{icon}</span>
                {text}
            </ListGroupItem>
        </Link>
    </Col>

export default ControlPanelItem


// WEBPACK FOOTER //
// ./src/components/ui/ControlPanelItem.js